import React from "react";
import "./AiEditProposal.css";

export interface PendingEditChange {
  field: string;
  from: string;
  to: string;
}

export interface PendingEditPayload {
  proposalId: string;
  eventId: string | number;
  eventName: string;
  changes: PendingEditChange[];
  expiresAt: string;
}

interface AiEditProposalProps {
  pending: PendingEditPayload;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Confirm / Cancel card for Ask Ev proposed event edits.
 */
const AiEditProposal: React.FC<AiEditProposalProps> = ({
  pending,
  busy,
  onConfirm,
  onCancel,
}) => {
  return (
    <div className="ai-edit-proposal">
      <p className="ai-edit-proposal-title">
        Proposed update for <strong>{pending.eventName}</strong>
      </p>
      <ul className="ai-edit-proposal-list">
        {pending.changes.map((c, i) => (
          <li key={`${c.field}-${i}`}>
            <span className="ai-edit-proposal-field">{c.field}</span>
            <span className="ai-edit-proposal-from">{c.from}</span>
            <span className="ai-edit-proposal-arrow" aria-hidden>
              →
            </span>
            <span className="ai-edit-proposal-to">{c.to}</span>
          </li>
        ))}
      </ul>
      <p className="ai-edit-proposal-hint">Nothing is saved until you confirm.</p>
      <div className="ai-edit-proposal-actions">
        <button
          type="button"
          className="v3-btn-secondary ai-edit-proposal-btn"
          onClick={onCancel}
          disabled={busy}
        >
          Cancel
        </button>
        <button
          type="button"
          className="v3-btn-primary ai-edit-proposal-btn"
          onClick={onConfirm}
          disabled={busy}
        >
          Confirm
        </button>
      </div>
    </div>
  );
};

export default AiEditProposal;

